import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NbLayoutModule, NbSidebarModule } from '@nebular/theme';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { CommonModule, DOCUMENT } from '@angular/common';
import { LayoutService } from './shared/services/layout.service';
import { ThemeService } from './shared/services/theme.service';
import { UserService } from './shared/services/user.service';
import { ThemeType } from './shared/enums/theme.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    NbLayoutModule,
    HeaderComponent,
    NbSidebarModule,
    SidebarComponent,
    RouterOutlet,
    FooterComponent,
  ],
})
export class AppComponent implements OnInit {
  title = 'SP Base Project';
  isIframe = false;
  showHeader = false;
  showSidebar = false;
  showFooter = false;

  constructor(
    protected layoutService: LayoutService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private themeService: ThemeService,
    private userService: UserService
  ) {
    const window = this.document.defaultView;
    this.isIframe = window !== window.parent && !window.opener;
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showHeader = this.activatedRoute.firstChild.snapshot.data['showHeader'] !== false;
        this.showSidebar = this.activatedRoute.firstChild.snapshot.data['showSidebar'] !== false;
        this.showFooter = this.activatedRoute.firstChild.snapshot.data['showFooter'] !== false;

        this.layoutService.toggleHeader(this.showHeader);
        this.layoutService.toggleSidebar(this.showSidebar);
        this.layoutService.toggleFooter(this.showFooter);

        if (this.showHeader) {
          this.userService.getCurrentUser().subscribe((user) => {
            const themeName = ThemeType[user.theme].toLowerCase();
            this.themeService.setTheme(themeName);
          });
        }
      }
    });
  }
}
